module.exports = __webpack_public_path__ + "img/it3.2174dc9e.png";